import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { LOGO_URL, formatErr } from "../lib/api";
import { Lock, Mail, ArrowRight } from "lucide-react";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("admin@upcel.com");
  const [password, setPassword] = useState("upcel123");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    // Clear any stale/expired token before trying fresh login
    localStorage.removeItem("upcel_token");
    try {
      await login(email, password);
      nav("/app/dashboard");
    } catch (e) {
      if (!e.response) {
        setErr("Sem conexão com o servidor. Verifique sua internet e tente novamente.");
      } else {
        setErr(formatErr(e.response?.data?.detail) || "E-mail ou senha incorretos.");
      }
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      {/* Left: brand side */}
      <div className="relative brand-navy text-white p-10 lg:p-16 flex flex-col justify-between overflow-hidden">
        <div className="absolute inset-0 opacity-30" style={{
          background: "linear-gradient(135deg, transparent 40%, #1E6BFF 55%, transparent 70%)"
        }} />
        <div className="relative z-10 flex items-center gap-3">
          <img src={LOGO_URL} alt="UP CEL Quilombo" className="w-14 h-14 object-cover rounded-sm" />
          <div>
            <div className="font-display font-bold text-2xl tracking-tight">UP CEL Quilombo</div>
            <div className="text-[10px] uppercase tracking-[0.3em] text-blue-300">Sistema de Gestão</div>
          </div>
        </div>

        <div className="relative z-10">
          <h1 className="font-display text-4xl lg:text-5xl font-bold leading-tight mb-4">
            Sua loja de celular<br />
            <span className="text-blue-400">100% no controle.</span>
          </h1>
          <p className="text-slate-300 text-base max-w-md">
            PDV, estoque, ordens de serviço, financeiro, catálogo online e muito mais — tudo em um só lugar.
          </p>
          <div className="mt-8 grid grid-cols-3 gap-3 max-w-md">
            {["PDV Rápido", "Estoque", "Ordens de Serviço", "WhatsApp", "Instagram", "Financeiro"].map((t) => (
              <div key={t} className="text-xs uppercase tracking-wider bg-white/5 border border-white/10 px-3 py-2 rounded-sm">
                {t}
              </div>
            ))}
          </div>
        </div>

        <div className="relative z-10 text-xs text-slate-500">© 2026 UP CEL Quilombo</div>
      </div>

      {/* Right: form */}
      <div className="flex items-center justify-center p-8 bg-white">
        <form onSubmit={submit} className="w-full max-w-md space-y-6" data-testid="login-form">
          <div>
            <h2 className="font-display text-3xl font-bold">Entrar</h2>
            <p className="text-slate-500 mt-1 text-sm">Acesse o painel de gestão da sua loja.</p>
          </div>

          {err && (
            <div className="bg-red-50 border border-red-200 text-red-700 text-sm p-3 rounded-sm" data-testid="login-error">
              {err}
            </div>
          )}

          <div>
            <label className="block text-xs uppercase tracking-wider text-slate-600 mb-1.5">Email</label>
            <div className="relative">
              <Mail size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
              <input
                type="email" required value={email}
                onChange={(e) => setEmail(e.target.value)}
                data-testid="login-email-input"
                className="w-full pl-10 pr-3 py-2.5 border border-slate-300 rounded-sm text-sm focus:outline-none focus:ring-2 focus:ring-[#2563EB] focus:border-[#2563EB]"
              />
            </div>
          </div>

          <div>
            <label className="block text-xs uppercase tracking-wider text-slate-600 mb-1.5">Senha</label>
            <div className="relative">
              <Lock size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
              <input
                type="password" required value={password}
                onChange={(e) => setPassword(e.target.value)}
                data-testid="login-password-input"
                className="w-full pl-10 pr-3 py-2.5 border border-slate-300 rounded-sm text-sm focus:outline-none focus:ring-2 focus:ring-[#2563EB] focus:border-[#2563EB]"
              />
            </div>
          </div>

          <button
            type="submit" disabled={loading}
            data-testid="login-submit-btn"
            className="w-full bg-[#2563EB] hover:bg-[#1D4ED8] text-white font-semibold py-3 rounded-sm text-sm flex items-center justify-center gap-2 transition-colors disabled:opacity-60"
          >
            {loading ? "Entrando..." : (<>Entrar no sistema <ArrowRight size={16} /></>)}
          </button>

          <div className="text-xs text-slate-500 bg-slate-50 border border-slate-200 p-3 rounded-sm">
            <div className="font-semibold text-slate-700 mb-1">Credenciais padrão:</div>
            Email: <code>admin@upcel.com</code><br />
            Senha: <code>upcel123</code>
          </div>

          <Link to="/catalog" data-testid="view-catalog-link" className="block text-center text-sm text-[#2563EB] hover:underline">
            Ver catálogo público →
          </Link>
        </form>
      </div>
    </div>
  );
}
